import React, { Component } from 'react'

import {
    Button,
    Spin,
    List,
    Modal,
    Input,
    Radio,
    Avatar, Empty, Space, Form, Select, notification
} from 'antd';
import {
    getMallUserList, getUserListForDropbox, handleUpdateDingDingUser,

} from '../../request'
import SysUserDetail from '../../components/SysUser/SysUserDetail'
import SysUserInfo from '../../components/SysUser/SysUserInfo'
import { apiPostRequest } from "../../http/http";

import './index.less'
export default class sysUserManagement extends Component {
    userItemDetailRef = React.createRef()

    state = {
        currentUserId: this.props.match.params.id || '',
        dataSource: [],
        userDropList: [],
        loading: false,
        visible: false,
        visibleModel: false,
        formParam: {
            status: 1
        }
    };
    initTableDataList = () => {
        this.setState({ loading: true });
        //用户列表
        getMallUserList({ ...this.state.formParam }).then(res => {
            let firstUserId = res.length > 0 ? res[0].userId : ''
            if (!this.state.currentUserId) {
                this.userItemDetailRef.current.initUserDetail(firstUserId)
            }
            this.setState({
                loading: false,
                dataSource: res,
                currentUserId: this.state.currentUserId || firstUserId,
            })
        })
    }

    handleCloseModel = () => {
        this.setState({
            visible: false,
            visibleModel: false
        })
    }
    searchChange = (value, option) => {
        console.log(value, option, this.state.formParam)
        let param = { ...this.state.formParam }
        this.setState({
            formParam: { ...param, userNameOrNick: value }
        }, () => {
            this.initTableDataList()
        })

    }
    handleSelectUser = (item) => {
        this.setState({
            currentUserId: item.userId,
        })
        this.userItemDetailRef.current.initUserDetail(item.userId)
        this.props.history.push(`/admin/sysuser/${item.userId}`)
    }
    handleStatus = (val) => {
        console.log(val)
        this.setState({
            loading: true,
            formParam: {
                ...this.state.formParam,
                status: val.target.value
            }
        }, () => {
            this.initTableDataList()
        })
    }
    handleAdd = () => {
        this.setState({
            visible: true
        })
    }
    handleOpenModel = () => {
        this.setState({
            visibleModel: true
        })
    }
    handleSaveUserInfo = () => {
        this.setState({
            visible: false
        })
        this.initTableDataList()
    }
    handleUserRight = (values) => {
        console.log(values)
        apiPostRequest('lechun-baseservice/user/transferUserPermissions', values).then(res => {
            this.handleCloseModel()
            this.initTableDataList()
        })
    }
    handleUpdateDingDingUserFun = () => {
        handleUpdateDingDingUser({}).then(res => {
            notification.success({
                message: '操作成功',
            });
            this.initTableDataList();
        })
    }
    componentDidMount() {
        this.initTableDataList()
        if (this.state.currentUserId != '') {
            this.userItemDetailRef.current.initUserDetail(this.state.currentUserId)
        }
        //下拉用户列表
        getUserListForDropbox().then(res => {
            this.setState({
                userDropList: res
            })
        })
    }

    render() {
        const { dataSource, currentUserId, loading } = this.state;
        return (
            <div className={'sys-user-management-container'}>

                <section className={'user-left'}>
                    <div className={'user-left-title'}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                            <span style={{ fontSize: '11px' }}>用户</span>
                            <Space.Compact size={'small'}>
                                <Button style={{ fontSize: '10px', padding: '0 6px' }} size={'small'} type={'primary'} shape="round" onClick={() => this.handleUpdateDingDingUserFun()}>钉钉同步</Button>
                                <Button style={{ fontSize: '10px', padding: '0 6px' }} size={'small'} type={'primary'} shape="round" onClick={this.handleOpenModel}>权限转移</Button>
                                <Button style={{ fontSize: '10px', padding: '0 6px' }} size={'small'} type={'primary'} shape="round" onClick={this.handleAdd}>新建用户</Button>
                            </Space.Compact>
                        </div>
                        <Input.Search
                            allowClear
                            placeholder="请搜索用户"
                            onSearch={this.searchChange}
                            style={{ width: '100%', marginBottom: '6px' }}
                        />
                        <Radio.Group onChange={this.handleStatus} size={'small'} defaultValue={1} style={{ display: 'flex', textAlign: 'center' }}>
                            <Radio.Button style={{ flex: 1 }} value={1}>启 用</Radio.Button>
                            <Radio.Button style={{ flex: 1 }} value={-1}>禁 用</Radio.Button>
                        </Radio.Group>
                        <div className={'user-left-title-num'}>用户数：{dataSource.length}</div>
                    </div>
                    {
                        dataSource.length > 0 ?
                            <List
                                size={'small'}
                                dataSource={dataSource}
                                renderItem={item => (
                                    <List.Item
                                        onClick={() => this.handleSelectUser(item)}
                                        className={currentUserId == item.userId ? 'user-item-active' : ''}
                                        key={item.userId}>
                                        <List.Item.Meta
                                            avatar={<Avatar src={item.avatar} size={20} />}
                                            title={item.userNick}
                                            description={item.userName}
                                        />
                                    </List.Item>
                                )}
                            /> : <Spin spinning={loading}><Empty /></Spin>
                    }

                </section>
                <section className={'user-right'}>
                    <SysUserDetail ref={this.userItemDetailRef} currentUserId={currentUserId} />
                </section>
                <Modal
                    title="新增用户"
                    width="570px"
                    open={this.state.visible}
                    destroyOnClose={true}
                    onCancel={this.handleCloseModel}
                    footer={null}
                >
                    <div className={'sys-user-management-modal'} style={{ height: '526px', overflowY: 'scroll' }}>
                        <SysUserInfo userDropList={this.state.userDropList} userInfo={{}} handleSaveUserInfo={this.handleSaveUserInfo} />
                    </div>

                </Modal>
                <Modal
                    title="权限转移/复制"
                    width="570px"
                    open={this.state.visibleModel}
                    destroyOnClose={true}
                    onCancel={this.handleCloseModel}
                    footer={null}
                >
                    <Form onFinish={this.handleUserRight}>
                        <Form.Item
                            label="权限选择"
                            name="operationType"
                            rules={[{ required: true, message: '请选择角色' }]}
                        >
                            <Radio.Group>
                                <Radio value={1}>复制权限</Radio>
                                <Radio value={2}>转移权限</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Form.Item
                                style={{ flex: 1, marginRight: '6px' }}
                                label="从"
                                name="sourceUserId"
                                rules={[{ required: true, message: '请选择角色' }]}
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="请选择用户"
                                    fieldNames={{ label: 'USER_NAME', value: 'USER_ID' }}
                                    filterOption={(input, option) =>
                                        (option?.USER_NAME ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={this.state.userDropList}
                                />
                            </Form.Item>
                            <Form.Item
                                style={{ flex: 1, marginRight: '6px' }}
                                label="转移/复制 到"
                                name="targetUserId"
                                rules={[{ required: true, message: '请选择用户' }]}
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="请选择用户"
                                    fieldNames={{ label: 'USER_NAME', value: 'USER_ID' }}
                                    filterOption={(input, option) =>
                                        (option?.USER_NAME ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={this.state.userDropList}
                                />
                            </Form.Item>
                        </div>
                        <Form.Item style={{ textAlign: 'right' }}>
                            <Button type="primary" htmlType={'submit'}>保存</Button>
                        </Form.Item>
                    </Form>

                </Modal>
            </div>
        )
    }
}